import { useEffect, useState } from 'react';
import axiosInstance from '../../config/axios.js';

export default function AgentSwitchTargets({
  visible,
  locationHubId,
  excludeUserId,
  selectedIds,
  knownTargets,
  onChange,
}) {
  const [candidates, setCandidates] = useState([]);

  useEffect(() => {
    if (!visible || !locationHubId) {
      setCandidates([]);
      return undefined;
    }
    let active = true;
    axiosInstance.get('/users/agent-switch/candidates', {
      params: {
        location_hub_id: locationHubId,
        exclude_user_id: excludeUserId || undefined,
      },
    }).then((response) => {
      if (active) setCandidates(response.data?.data || []);
    }).catch(() => {
      if (active) setCandidates([]);
    });
    return () => {
      active = false;
    };
  }, [visible, locationHubId, excludeUserId]);

  if (!visible) return null;

  const byId = new Map();
  (knownTargets || []).forEach((agent) => byId.set(agent.user_id, agent));
  candidates.forEach((agent) => byId.set(agent.user_id, agent));
  const rows = Array.from(byId.values());

  const toggle = (userId) => {
    if (selectedIds.includes(userId)) {
      onChange(selectedIds.filter((id) => id !== userId));
      return;
    }
    onChange([...selectedIds, userId]);
  };

  return (
    <div className="sm:col-span-2 border border-gray-200 rounded-xl p-4">
      <p className="text-sm font-semibold text-gray-800">Agents this user can handle</p>
      <p className="text-xs text-gray-500 mt-1 mb-3">
        Search a location above, then tick the agents at that location. The user can work as one of them at a time.
      </p>
      {!locationHubId && (
        <p className="text-sm text-gray-500">Select a location to list agents.</p>
      )}
      {locationHubId && rows.length === 0 && (
        <p className="text-sm text-gray-500">No other active agents on this location.</p>
      )}
      <div className="space-y-2">
        {rows.map((agent) => (
          <label key={agent.user_id} className="flex items-start gap-2 text-sm text-gray-800">
            <input
              type="checkbox"
              className="mt-1"
              checked={selectedIds.includes(agent.user_id)}
              onChange={() => toggle(agent.user_id)}
            />
            <span>
              <span className="font-medium">{agent.name}</span>
              <span className="text-gray-500"> ({agent.user_id})</span>
              {agent.location ? <span className="block text-xs text-gray-500">{agent.location}</span> : null}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
}
